import React from 'react';
import { motion } from 'framer-motion';

interface AnimationHoverProps {
  children: React.ReactNode;
}

export const AnimationHover: React.FC<AnimationHoverProps> = ({ children }) => {
  return (
    <motion.div
      className={`w-full flex flex-col items-center`}
      whileHover={{ scale: 1.05 }}
      transition={{ type: 'spring', stiffness: 400, damping: 10 }}
    >
      {children}
    </motion.div>
  );
};
